import { useQuery } from '@tanstack/react-query';
import { fetchDashboardById } from '@api/dashboard';

/**
 * Custom hook to load a report by ID using React Query
 * - No caching (gcTime: 0) - always fetch fresh data
 * - Deduplication of in-flight requests
 * - Loading states and error handling
 */
export function useReport(id) {
  const { data: report, isLoading: loading, error } = useQuery({
    queryKey: ['dashboard', id],
    queryFn: async () => {
      const result = await fetchDashboardById(id);
      if (result.status === 'success' && result.data) {
        return result.data;
      }
      throw new Error(result.message || 'Failed to load report');
    },
    enabled: !!id,
    gcTime: 0, // No caching
    staleTime: 0,
  });

  // Throw error for ErrorBoundary to catch
  if (error) {
    throw error;
  }

  return { report: report || null, loading };
}

export default useReport;
